module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-post-fill-a92beec8.svg";